import React from "react";
import { createRoot } from "react-dom/client";
import App from "./GridDemo";

const root = createRoot(document.body);
root.render(<App />);
